<template>
  <BContainer>
    <b-row>
      <MutualFund />
    </b-row>
    <b-row class="mt-5">
      <navSipRolling />
    </b-row>
    <b-row class="mt-7">
      <fundRatings />
    </b-row>
    <b-row class="mt-7">
      <PerformanceFund />
    </b-row>
    <b-row class="mt-7">
      <portFolio />
    </b-row>
    <b-row class="mt-7">
      <riskSuitabiility />
    </b-row>
    <b-row class="mt-7">
      <otherInformation />
    </b-row>
    <b-row class="mt-7">
      <expenseRatio />
    </b-row>
    <b-row class="mt-7 faq-sec">
      <faqSectionPrp />
    </b-row>
  </BContainer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import MutualFund from './components/mutualFund.vue'
import otherInformation from './components/otherInformation.vue'
import portFolio from './components/portFolio.vue'
import fundRatings from './components/fundRatings.vue'
import expenseRatio from './components/expenseRatio.vue'
import navSipRolling from './components/navSipRollingDeturns.vue'
import riskSuitabiility from './components/riskSuitability.vue'
import PerformanceFund from './components/performanceFund.vue'
import faqSectionPrp from './components/FAQsection_prp_home.vue'
export default {
  name: 'App',
  components: {
    MutualFund,
    otherInformation,
    fundRatings,
    portFolio,
    expenseRatio,
    navSipRolling,
    riskSuitabiility,
    PerformanceFund,
    faqSectionPrp,
  },
  computed: {
    ...mapGetters(['loading', 'schemeData', 'error']),
    isLoading() {
      return this.loading
    },
  },
  methods: {
    ...mapActions(['fetchSchemeData']),
  },
  mounted() {
    this.fetchSchemeData()
  },
}
</script>

<style scoped>
#app {
  background: linear-gradient(180deg, #e3fdff 0%, #ffffff 25%) !important;
}

.faq-sec {
  width: 100vw;
  margin-left: calc(-50vw + 50%);
  background: #f5f7f9;
  padding: 40px 20px;;
}
</style>
